export { default } from './TaskOwnerItem';



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksListAsOwner/TaskItemAsOwner/index.js